import ServicePage from './ServicePage';

const RemediationCognitive = () => <ServicePage serviceKey="cognitiveRemediation" />;

export default RemediationCognitive;
